<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="1343"></ucMenu>
					<div class="right_con">
						<el-card shadow="never" style="min-height:650px;">
								<div v-if="loading" class="loading">加载中...</div>

								<div v-else-if="task" class="task-content">
									<!-- 返回按钮 -->
									<div class="back-btn" @click="goBack">
										<i class="el-icon-arrow-left"></i> 返回任务大厅
									</div>

									<!-- 任务头部 -->
									<div class="task-header">
										<div class="task-title-section">
											<h1>{{ task.task_name }}</h1>
											<span class="task-status" :class="task.status">
												{{ getStatusText(task.status) }}
											</span>
										</div>
										<p class="task-description">{{ task.task_description }}</p>
										<div class="task-trigger" v-if="task.conditions || task.trigger_type">
											<span class="trigger-label">触发条件：</span>
											<span class="trigger-value">{{ formatTriggerCondition(task) }}</span>
										</div>
									</div>

									<!-- 完成步骤 -->
									<div v-if="task.steps && task.steps.length > 0" class="steps-section">
										<h2>完成步骤</h2>
										<div class="steps-list">
											<div
												v-for="step in task.steps"
												:key="step.step_number"
												class="step-item"
											>
												<div class="step-number">{{ step.step_number }}</div>
												<div class="step-content">
													<h3>{{ step.step_title }}</h3>
													<p>{{ step.step_description }}</p>
													<img v-if="step.step_image" :src="step.step_image" class="step-image" />
												</div>
											</div>
										</div>
									</div>

									<!-- 操作按钮 -->
									<div class="action-section">
										<el-button
											v-if="task.status === 'pending' || task.status === 'in_progress'"
											type="primary"
											size="medium"
											@click="handleCompleteTask"
										>
											完成任务
										</el-button>
										<div v-else-if="task.status === 'completed'" class="completed-tip">
											<i class="el-icon-success"></i>
											任务已完成
										</div>
										<div v-else-if="task.status === 'expired'" class="expired-tip">
											<i class="el-icon-warning"></i>
											任务已过期
										</div>
									</div>

									<!-- 任务信息 -->
									<div class="task-info">
										<div class="info-item">
											<span class="info-label">分配时间:</span>
											<span class="info-value">{{ formatTime(task.assigned_at) }}</span>
										</div>
										<div v-if="task.expires_at" class="info-item">
											<span class="info-label">过期时间:</span>
											<span class="info-value">{{ formatTime(task.expires_at) }}</span>
										</div>
										<div v-if="task.completed_at" class="info-item">
											<span class="info-label">完成时间:</span>
											<span class="info-value">{{ formatTime(task.completed_at) }}</span>
										</div>
									</div>
								</div>
						</el-card>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>

<script>
import myHead from '@/components/myHead/myhead.vue'
import myFoot from '@/components/myFoot/myfoot.vue'
import ucMenu from '@/components/ucenterMenu/ucmenu.vue'
import { getTaskDetail, completeTask } from '@/api/main/task'

export default {
	name: 'TaskDetail',
	components: {
		myHead,
		myFoot,
		ucMenu
	},
	data() {
		return {
			loading: false,
			task: null,
			taskId: null
		}
	},
	mounted() {
		this.taskId = this.$route.query.task_id
		if (this.taskId) {
			this.loadData()
		}
	},
	methods: {
		async loadData() {
			this.loading = true
			try {
				const res = await getTaskDetail({ task_id: this.taskId })
				if (res.code === 200) {
					this.task = res.data
				}
			} catch (error) {
				console.error('加载任务详情失败:', error)
				this.$message.error('加载任务详情失败')
			} finally {
				this.loading = false
			}
		},
		async handleCompleteTask() {
			try {
				const res = await completeTask({ task_id: this.taskId })
				if (res.code === 200) {
					this.$message.success(res.message || '任务完成！')
					this.loadData()
				} else {
					this.$message.error(res.message || '完成任务失败')
				}
			} catch (error) {
				console.error('完成任务失败:', error)
				this.$message.error('完成任务失败')
			}
		},
		goBack() {
			this.$router.push({
				path: '/uc_task_hall',
				query: { menuId: 1343 }
			})
		},
		getStatusText(status) {
			const statusMap = {
				pending: '待开始',
				in_progress: '进行中',
				completed: '已完成',
				expired: '已过期'
			}
			return statusMap[status] || status
		},
		formatTriggerCondition(task) {
			const conditions = task.conditions || []

			// 如果 conditions 是空数组或不存在，返回默认文本
			if (!Array.isArray(conditions) || conditions.length === 0) {
				return '无触发条件'
			}

			// 指标字段映射
			const metricFieldMap = {
				pay_amt: '用户支付金额',
				income_amt: '成交金额',
				pay_cnt: '成交订单数',
				pay_ucnt: '成交人数',
				product_show_ucnt: '商品曝光人数',
				product_click_ucnt: '商品点击人数',
				product_show_cnt: '商品曝光次数',
				product_click_cnt: '商品点击次数',
				product_show_click_cnt_ratio: '商品点击率'
			}

			// 操作符映射
			const operatorMap = {
				gt: '>',
				gte: '≥',
				lt: '<',
				lte: '≤',
				between: '介于',
				eq: '='
			}

			// 单位映射
			const unitMap = {
				pay_amt: '元',
				income_amt: '元',
				pay_cnt: '单',
				pay_ucnt: '人',
				product_show_ucnt: '人',
				product_click_ucnt: '人',
				product_show_cnt: '次',
				product_click_cnt: '次',
				product_show_click_cnt_ratio: '%'
			}

			// 格式化所有条件
			const conditionTexts = conditions.map(condition => {
				const metricName = metricFieldMap[condition.metric_field] || condition.metric_field
				const operator = operatorMap[condition.operator] || condition.operator
				const unit = unitMap[condition.metric_field] || ''

				if (condition.operator === 'between') {
					return `${metricName} ${operator} ${condition.value_min}${unit} - ${condition.value_max}${unit}`
				} else {
					return `${metricName} ${operator} ${condition.value_min}${unit}`
				}
			})

			// 用逗号连接多个条件
			return conditionTexts.join('，')
		},
		formatValue(value) {
			if (typeof value === 'number') {
				return value.toLocaleString()
			}
			return value
		},
		formatTime(time) {
			if (!time) return '-'
			return new Date(time).toLocaleString('zh-CN')
		}
	}
}
</script>

<style scoped>
/* 基础布局 */

.center{display: flex;flex: 1;}

.el-card__body{padding:12px 20px;}

/* 加载状态 */
.loading {
	text-align: center;
	padding: 60px 20px;
	color: #999;
	font-size: 14px;
}

/* 任务内容 */
.task-content {
	padding: 10px 0;
}

/* 返回按钮 */
.back-btn {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	color: #666;
	cursor: pointer;
	margin-bottom: 20px;
	font-size: 14px;
}

.back-btn:hover {
	color: #f0413e;
}

/* 任务头部 */
.task-header {
	margin-bottom: 25px;
	padding-bottom: 20px;
	border-bottom: 1px solid #eee;
}

.task-title-section {
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 12px;
}

.task-title-section h1 {
	font-size: 24px;
	font-weight: 600;
	color: #333;
	margin: 0;
}

.task-status {
	padding: 5px 14px;
	border-radius: 12px;
	font-size: 13px;
}

.task-status.pending {
	background: #e8f4ff;
	color: #1890ff;
}

.task-status.in_progress {
	background: #fff7e6;
	color: #fa8c16;
}

.task-status.completed {
	background: #f6ffed;
	color: #52c41a;
}

.task-status.expired {
	background: #fff1f0;
	color: #ff4d4f;
}

.task-description {
	font-size: 14px;
	color: #666;
	line-height: 1.6;
	margin: 0 0 12px 0;
}

.task-trigger {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	padding: 10px 14px;
	background: #f8f9fa;
	border-radius: 6px;
	margin-top: 12px;
}

.trigger-label {
	color: #999;
	font-weight: 500;
}

.trigger-value {
	color: #333;
	font-weight: 600;
}

/* 各个区块 */
.steps-section {
	margin-bottom: 25px;
}

.steps-section h2 {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 15px;
	color: #333;
}

/* 步骤列表 */
.steps-list {
	display: flex;
	flex-direction: column;
	gap: 18px;
}

.step-item {
	display: flex;
	gap: 14px;
}

.step-number {
	width: 32px;
	height: 32px;
	background: #f0413e;
	color: #fff;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	flex-shrink: 0;
	font-size: 14px;
}

.step-content {
	flex: 1;
}

.step-content h3 {
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 6px;
	color: #333;
}

.step-content p {
	font-size: 13px;
	color: #666;
	line-height: 1.6;
	margin-bottom: 10px;
}

.step-image {
	max-width: 100%;
	border-radius: 6px;
	margin-top: 10px;
}

/* 操作区域 */
.action-section {
	margin-bottom: 25px;
	text-align: center;
}

.action-section .el-button {
	width: 180px;
}

.completed-tip, .expired-tip {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 10px 20px;
	border-radius: 6px;
	font-size: 14px;
}

.completed-tip {
	background: #f6ffed;
	color: #52c41a;
}

.expired-tip {
	background: #fff1f0;
	color: #ff4d4f;
}

/* 任务信息 */
.task-info {
	padding-top: 18px;
	border-top: 1px solid #eee;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.info-item {
	display: flex;
	font-size: 13px;
}

.info-label {
	color: #999;
	width: 90px;
}

.info-value {
	color: #333;
}
</style>
